import React from 'react';
import defaultTheme from "../defaultTheme";
var ThemeContext = /*#__PURE__*/React.createContext(defaultTheme);
export default ThemeContext;